import { Box, Divider } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { CraneSplitContent, CraneSplitHeader, useOperationsStore } from '@tom-ui/operations'
import { usePlanningStore, VesselVisitOverview } from '@tom-ui/planning'
import { Header, useMinimalsTheme } from '@tom-ui/ui'
import { PATHS, useAsyncFetch, withAuthenticationRequired } from '@tom-ui/utils'
import { computed } from 'mobx'
import { observer } from 'mobx-react-lite'
import { useNavigate, useParams } from 'react-router'

export const CraneSplitPage = withAuthenticationRequired(
  observer(() => {
    const { equipmentPlanningUIStore } = useOperationsStore()
    const { vesselVisitQueryService, vesselVisitItemStore } = usePlanningStore()
    const { id } = useParams()
    const navigate = useNavigate()
    const theme = useMinimalsTheme()
    const { t } = useTranslate()

    const vesselVisitId = Number(id)
    if (!vesselVisitId) {
      navigate(PATHS.visits.vesselVisits.url)
    }

    useAsyncFetch(async () => {
      await vesselVisitQueryService.fetchById(vesselVisitId)
    }, [vesselVisitId, vesselVisitQueryService])

    const vesselVisitItem = computed(() => vesselVisitItemStore.elements[vesselVisitId]).get()
    const remarks = computed(() => {
      if (!vesselVisitItem) return ''

      const remarks: string[] = []

      vesselVisitItem.vessels.forEach(vessel => {
        if (vessel.data.remarks) {
          remarks.push(vessel.data.remarks)
        }
      })

      return remarks.join(', ')
    }).get()

    return (
      <Box
        sx={{
          bgcolor: !equipmentPlanningUIStore.craneSplitContainerUIStore.isExporting
            ? theme.palette.grey[100]
            : 'white',
          minHeight: '100%',
        }}
        id='crane-split-page'
      >
        {!equipmentPlanningUIStore.craneSplitContainerUIStore.isExporting && (
          <CraneSplitHeader
            equipmentPlanningUIStore={equipmentPlanningUIStore}
            visitId={vesselVisitId}
          />
        )}

        {equipmentPlanningUIStore.craneSplitContainerUIStore.isExporting && (
          <Header title={t('craneSplit', 'Crane split')} position='relative' />
        )}
        {vesselVisitItem && (
          <VesselVisitOverview vesselVisitItem={vesselVisitItem} isEditDisabled={true} />
        )}
        {!equipmentPlanningUIStore.craneSplitContainerUIStore.isExporting && <Divider />}

        <CraneSplitContent equipmentPlanningUIStore={equipmentPlanningUIStore} remarks={remarks} />
      </Box>
    )
  }),
)
